import schema, { generateType } from './Schema';
export const LibraryShare = generateType(schema.getModel('libraryShare'))
    .views((self) => ({
    // This is aso we can get the id in a consistent way across Library and LibraryShare
    getLibraryID() {
        return self.libraryID;
    },
}));
//# sourceMappingURL=LibraryShareModel.js.map